import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { StyledButton } from "./styles";

interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  bold?: boolean;
  loading?: boolean;

  children?: React.ReactNode;
}

export const Button: React.FC<IButton> = ({
  loading = false,
  bold = false,
  children,
  ...props
}) => {
  return (
    <StyledButton {...props} bold={bold} loading={loading}>
      <span>{children}</span>
    </StyledButton>
  );
};

interface INavButton extends IButton {
  navigate?: string;
}

export const NavButton: React.FC<INavButton> = ({
  loading = false,
  bold = false,
  navigate,
  children,
  ...props
}) => {
  const nav = useNavigate();
  const { i18n } = useTranslation();

  return (
    <StyledButton
      bold={bold}
      loading={loading}
      onClick={() => navigate && nav(`/${i18n.language}${navigate.slice(5)}`)}
      {...props}
    >
      <span>{children}</span>
    </StyledButton>
  );
};
